/**
 * Mappers for security grouping create operations
 */

import type { LC_CreateSecurityGroupingOut, SecurityGrouping } from '../types';


export function mapCreatedSecurityGroupingToModel(
  transport: LC_CreateSecurityGroupingOut,
): SecurityGrouping {
  return {
    id: transport.id,
    code: transport.code,
    name: transport.groupName,
    sendsAttendanceStatus: transport.sendsAttendanceStatus,
    isActive: transport.enabled,
  };
}
